
import React from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle, Edit, EyeOff } from "lucide-react";

interface PublishedExpertActionsProps {
  onEdit: () => void;
  onUnpublish: () => void;
  loading: boolean;
}

export default function PublishedExpertActions({ 
  onEdit, 
  onUnpublish, 
  loading 
}: PublishedExpertActionsProps) {
  return (
    <div className="space-y-3">
      <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
        <div className="flex items-center gap-2 text-green-800">
          <CheckCircle className="h-4 w-4" />
          <span className="text-sm font-medium">Expert is Live</span>
        </div>
        <p className="text-xs text-green-600 mt-1">
          This expert is published and visible to clients
        </p>
      </div>
      
      <div className="space-y-2">
        <h4 className="font-medium text-sm">Published Expert Actions</h4>
        
        <Button
          onClick={onEdit}
          variant="outline"
          className="w-full justify-between border-blue-200 text-blue-700 hover:bg-blue-50"
          disabled={loading}
        >
          <span className="flex items-center gap-2">
            <Edit className="h-4 w-4" />
            Edit Profile
          </span>
        </Button>
        
        <Button
          onClick={onUnpublish}
          variant="outline"
          className="w-full justify-between border-orange-200 text-orange-700 hover:bg-orange-50"
          disabled={loading}
        >
          <span className="flex items-center gap-2">
            <EyeOff className="h-4 w-4" />
            Unpublish Expert
          </span>
        </Button>
      </div>
    </div>
  );
}
